
import { useState } from 'react';
import { toast } from 'sonner';

/**
 * This is a simplified version that replaces the old thumbnail refresh functionality.
 * For full metadata extraction, use useReWebClipContent instead.
 */
export const useRefreshThumbnails = (refetch: () => Promise<unknown>) => {
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefreshThumbnails = async () => {
    if (isRefreshing) return;

    setIsRefreshing(true);
    toast.info("Refreshing content...");
    
    try {
      await refetch();
      toast.success("Content refreshed");
    } catch (error) {
      console.error("Error refreshing content:", error);
      toast.error("Failed to refresh content");
    } finally {
      setIsRefreshing(false);
    }
  };

  return {
    isRefreshing,
    handleRefreshThumbnails
  };
};
